import { render, staticRenderFns } from "./ProductVariantSuppliers.vue?vue&type=template&id=6e6bd638&scoped=true"
import script from "./ProductVariantSuppliers.vue?vue&type=script&lang=js"
export * from "./ProductVariantSuppliers.vue?vue&type=script&lang=js"
import style0 from "./ProductVariantSuppliers.vue?vue&type=style&index=0&id=6e6bd638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6bd638",
  null
  
)

export default component.exports